var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-sidebar-wrapper" },
    [
      _c("SidebarChild", {
        attrs: {
          "default-open": true,
          "title-enabled": true,
          "selected-item": _vm.getSelectedItem(),
          tabs: _vm.getMenuTabs(),
          items: _vm.getMenuItems(),
          focusActive: true,
          "enable-non-grouped-draggable": true,
          className: "chat-menu",
        },
        on: {
          selected: _vm.selectedItem,
          contextmenu: _vm.handleContextMenu,
          dragEnd: _vm.handleDragEnd,
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "sidebar-title-text" }, [
                  _vm._v(_vm._s(_vm.$t("chat.inbox"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "sidebar-title-actions" },
                  [
                    _c(
                      "Tooltip",
                      { attrs: { title: _vm.$t("chat.sidebar.tabScreen") } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "sidebar-title-action",
                            on: { click: _vm.openTabScreen },
                          },
                          [
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v("backup_table"),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "Tooltip",
                      { attrs: { title: _vm.$t("chat.sidebar.search") } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "sidebar-title-action",
                            on: { click: _vm.search },
                          },
                          [
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v("search"),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "Views-empty",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "empty-group-item",
                    on: { click: _vm.addNewFilter },
                  },
                  [
                    _c("div", { staticClass: "empty-group-item-icon" }, [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("add_circle_outline"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "empty-group-item-content" }, [
                      _c("div", { staticClass: "empty-group-item-text" }, [
                        _vm._v(_vm._s(_vm.$t("chat.sidebar.addNewFilter"))),
                      ]),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.contextMenuVisible
        ? _c(
            "div",
            {
              staticClass: "inbox-context-menu",
              style: {
                left: _vm.contextMenuX + "px",
                top: _vm.contextMenuY + "px",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "context-menu-item",
                  on: { click: _vm.handleEdit },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("edit")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("chat.sidebar.edit")))]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "context-menu-item",
                  on: { click: _vm.handleOpenInTable },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("table_chart"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("chat.sidebar.showInTable"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "context-menu-item",
                  on: { click: _vm.handleOpenInKanban },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("view_kanban"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("chat.sidebar.showInKanban"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.isCustomFilter
                ? [
                    _c("div", { staticClass: "context-menu-divider" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "context-menu-item",
                        on: { click: _vm.handleRename },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("drive_file_rename_outline"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("chat.sidebar.rename"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "context-menu-item",
                        on: { click: _vm.handleEditDescription },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("description"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("chat.sidebar.editDescription"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "context-menu-item",
                        on: { click: _vm.handleToggleVisibility },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$_.get(_vm.selectedFilter, "visibility") ===
                                "private"
                                ? "lock_open"
                                : "lock"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$_.get(_vm.selectedFilter, "visibility") ===
                                "private"
                                ? _vm.$t("chat.sidebar.makePublic")
                                : _vm.$t("chat.sidebar.makePrivate")
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "context-menu-divider" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "context-menu-item",
                  on: { click: _vm.handleMoveToTop },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("vertical_align_top"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("chat.sidebar.moveToTop"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "context-menu-item",
                  on: { click: _vm.handleMoveToBottom },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("vertical_align_bottom"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("chat.sidebar.moveToBottom"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.isCustomFilter
                ? [
                    _c("div", { staticClass: "context-menu-divider" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "context-menu-item danger",
                        on: { click: _vm.handleDelete },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("delete"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("chat.sidebar.delete"))),
                        ]),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.renameModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                design: "v3",
                "show-footer": false,
                title: _vm.$t("chat.sidebar.renameFilterTitle"),
                "class-name": "chat-sidebar-rename-modal",
              },
              on: {
                cancel: function ($event) {
                  _vm.renameModalVisible = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "chat-sidebar-rename-modal-inner" },
                [
                  _c("a-input", {
                    staticClass: "chat-sidebar-modal-input",
                    attrs: {
                      placeholder: _vm.$t("chat.sidebar.filterNamePlaceholder"),
                    },
                    on: { pressEnter: _vm.handleRenameSubmit },
                    model: {
                      value: _vm.renameValue,
                      callback: function ($$v) {
                        _vm.renameValue = $$v
                      },
                      expression: "renameValue",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "chat-sidebar-modal-actions" },
                    [
                      _c(
                        "SupsisButton",
                        {
                          on: {
                            click: function ($event) {
                              _vm.renameModalVisible = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("auto.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: { primary: "" },
                          on: { click: _vm.handleRenameSubmit },
                        },
                        [_vm._v(_vm._s(_vm.$t("auto.save")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.descriptionModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                design: "v3",
                "show-footer": false,
                title: _vm.$t("chat.sidebar.editDescriptionTitle"),
                "class-name": "chat-sidebar-description-modal",
              },
              on: {
                cancel: function ($event) {
                  _vm.descriptionModalVisible = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "chat-sidebar-description-modal-inner" },
                [
                  _c("div", { staticClass: "chat-sidebar-desc-field" }, [
                    _c(
                      "label",
                      {
                        staticClass: "chat-sidebar-desc-label",
                        attrs: { for: "chat-sidebar-filter-desc-input" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("chat.filterPanel.filterDescriptionLabel")
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "chat-sidebar-desc-hint",
                        attrs: { role: "note" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "chat-sidebar-desc-hint-head" },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "chat-sidebar-desc-hint-head-icon material-icons",
                                attrs: { "aria-hidden": "true" },
                              },
                              [_vm._v("tips_and_updates")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "chat-sidebar-desc-hint-title" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "chat.sidebar.descriptionFormatHintTitle"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "chat-sidebar-desc-hint-text" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("chat.sidebar.descriptionFormatHint")
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "chat-sidebar-desc-textarea-wrap" },
                      [
                        _c("a-textarea", {
                          staticClass: "chat-sidebar-modal-textarea",
                          attrs: {
                            id: "chat-sidebar-filter-desc-input",
                            rows: 8,
                            placeholder: _vm.$t(
                              "chat.filterPanel.filterDescriptionPlaceholder"
                            ),
                          },
                          model: {
                            value: _vm.descriptionEditValue,
                            callback: function ($$v) {
                              _vm.descriptionEditValue = $$v
                            },
                            expression: "descriptionEditValue",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "chat-sidebar-modal-actions" },
                    [
                      _c(
                        "SupsisButton",
                        {
                          on: {
                            click: function ($event) {
                              _vm.descriptionModalVisible = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("auto.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: { primary: "" },
                          on: { click: _vm.handleDescriptionSubmit },
                        },
                        [_vm._v(_vm._s(_vm.$t("auto.save")))]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }